import { render, staticRenderFns } from "./industryCase.vue?vue&type=template&id=b1cdbde0&scoped=true&"
import script from "./industryCase.vue?vue&type=script&lang=js&"
export * from "./industryCase.vue?vue&type=script&lang=js&"
import style0 from "./industryCase.vue?vue&type=style&index=0&id=b1cdbde0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cdbde0",
  null
  
)

export default component.exports